import { FormGroup, TextArea } from '@blueprintjs/core'
import classNames from 'classnames'
import React, { SFC } from 'react'

import { SyncIndicator } from './sync-indicator'
import { FieldAdapterProps, TextAreaProps } from './types'
import { createHelperText, createLabelWithId, createRequiredLabel, getIntent, identity } from './utils'

export type Props = FieldAdapterProps<TextAreaProps>

import { removalOfNotSupportedCharacters } from 'app/aspire/common/util/unsupported-chars-util'
import { isPresent } from 'app/shared'
import './textarea-adapter.scss'

const TextareaAdapter: SFC<Props> = ({
  input,
  meta,
  label,
  placeholder,
  helperText,
  disabled = false,
  inline,
  required,
  intent,
  rows,
  hint,
  enableSyncControl,
  autoFocus = false,
  translate = identity,
  hideLabel = false,
  maxCharsCount,
  // tslint:disable-next-line:no-empty
  onSyncChange = (fieldName: string, newValue: boolean) => {},
}) => {
  const { id, labelText } = createLabelWithId(input, label)

  input.value = removalOfNotSupportedCharacters(input.value)
  input.value = trimOfCharsAboveThreshold(input.value, maxCharsCount)

  const intentType = getIntent(meta, intent)
  const helperTextMessage = createHelperText(meta, helperText, translate)
  const labelInfo = createRequiredLabel(required, translate)
  const inputCharCount = input.value.length
  const charsLeft = maxCharsCount ? maxCharsCount - inputCharCount : 0

  const reqLabelMod = (
    <>
      {labelInfo}
      {enableSyncControl && (
        <SyncIndicator translate={translate} fieldName={input.name} disabled={disabled} onSyncChange={onSyncChange} />
      )}
    </>
  )

  const textareaClassName = classNames('textarea', {
    'textarea--has-hint': isPresent(hint),
  })

  const labelClassName = classNames({
    required: !!labelInfo,
    'bp3-hide-label': hideLabel,
  })

  const charsLeftClassName = classNames('textarea__chars-left', {
    'textarea__chars-left--exceeded': charsLeft <= 0,
  })

  return (
    <FormGroup
      className={labelClassName}
      helperText={helperTextMessage}
      label={labelText}
      labelFor={id}
      labelInfo={reqLabelMod}
      intent={intentType}
      inline={inline}
      disabled={disabled}
    >
      <TextArea
        className={textareaClassName}
        id={id}
        {...input}
        placeholder={placeholder}
        fill={!hint}
        rows={rows}
        intent={intentType}
        autoFocus={autoFocus}
        disabled={disabled}
      />
      {maxCharsCount && <div className={charsLeftClassName}>{`${charsLeft}/${maxCharsCount}`}</div>}
      {hint && <div className="textarea__hint">{hint}</div>}
    </FormGroup>
  )
}

const trimOfCharsAboveThreshold = (currentValue?: string, maxCharsCount?: number) => {
  if (maxCharsCount && currentValue) {
    return currentValue.slice(0, maxCharsCount)
  }

  return currentValue
}

export { TextareaAdapter }



// WEBPACK FOOTER //
// ./src/modules/forms/textarea-adapter.tsx